import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions, permissionActions, inventoryActions, chatActions, notificationActions } from '../_actions';
import InventoryAlertModal from '../common/InventoryAlertModal';
import { authHeader, config } from '../_helpers';
import moment from 'moment';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import NumberFormat from 'react-number-format';
import { dateTimeConstants, userConstants } from '_constants';
import Modal from 'react-responsive-modal';
import ReactModal from 'react-modal';
import NewModal from 'react-responsive-modal';
import DatePicker from 'react-datepicker';
import { formatDate } from '_helpers/helpers';
import { profileService } from '_services/profile.service';
import { handleErrorResponse } from '_helpers/helpers';
import { docsService } from '../_services/docs.service';
import {
  ProfileHeader,
} from '../common/Profile';
import TabNavigation from '../common/Profile/TabNavigation';
import TabContent from '../common/Profile/TabContent';

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hash: this.props.hash,
      tab: 'profile',
      statusOpen: false,
      removeOpen: false,
      inventoryUserAlert: false,
      archiveStep: '3a',
      mailSendOpen: false,
      email: true,
      sms: true,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      message: '',
      alertPop: false,
      userName: '',
      alertOpen: false,
      isGuest: false,
      unavailableReason: 0,
      otherReason: '',
      savingNote: false,
      reloadKey: 0,
      loader: false,
      lastDayWorked: moment(),
      lastDayReason: '',
      lastDayReasonErr: '',
      sendingDDForm: false,
      send_dd_form_confirm: false,
      request_rehire_doc: false,
      request_rehire_doc_status: false,
      doc_request: '',
      // Lock profile states
      is_locked: 0,
      requireDocs: false,
      inventoryAlertAction: 'remove',
    };
    this.goBack = this.goBack.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.removeOpenModal = this.removeOpenModal.bind(this);
    this.handleLockProfile = this.handleLockProfile.bind(this);
    this.lockProfile = this.lockProfile.bind(this);
    this.unlockProfile = this.unlockProfile.bind(this);
    this.remove = this.remove.bind(this);
    this.removeCloseModal = this.removeCloseModal.bind(this);
    this.alertOpenModal = this.alertOpenModal.bind(this);
    this.alertCloseModal = this.alertCloseModal.bind(this);
    this.mailSendOpenModal = this.mailSendOpenModal.bind(this);
    this.mailSendCloseModal = this.mailSendCloseModal.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.collectLastDayWorked = this.collectLastDayWorked.bind(this);
    this.openDdformConfirmModal = this.openDdformConfirmModal.bind(this);
    this.ddFormConfirmCloseModal = this.ddFormConfirmCloseModal.bind(this);
    this.sendDDForm = this.sendDDForm.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.documentRequest = this.documentRequest.bind(this);
    this.docRequestModalClose = this.docRequestModalClose.bind(this);
    this.downloadAllDocuments = this.downloadAllDocuments.bind(this);
    this.downloadAllDocumentsAsPDF = this.downloadAllDocumentsAsPDF.bind(this);
  }

  collectLastDayWorked() {
    this.setState({ archiveStep: '3b' });
  }

  changeLastDayReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      lastDayReasonErr: '',
    });
  };

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  statusCloseModal() {
    this.setState({ statusOpen: false });
  }

  removeOpenModal() {
    let inventoryList = this.props.inventory?.inventory?.data || [];
    if (inventoryList?.length) {
      this.setState({ inventoryUserAlert: true, inventoryAlertAction: 'remove', statusOpen: false });
    } else {
      this.setState({ removeOpen: true });
    }
  }

  handleLockProfile(e) {
    let inventoryList = this.props.inventory?.inventory?.data || [];
    if (inventoryList?.length) {
      this.setState({ inventoryUserAlert: true, inventoryAlertAction: 'lock', statusOpen: false });
    } else {
      this.setStep('1b');
    }
  }

  removeCloseModal() {
    this.setState({ removeOpen: false, archiveStep: '3a' });
  }

  alertOpenModal() {
    this.setState({ alertOpen: true });
  }

  alertCloseModal() {
    this.setState({ alertOpen: false, redirect: '/resources' }, () => {
      this?.props.dispatch({
        type: userConstants?.REMOVEPROFILE_SUCCESS,
        removeUser: null,
      });
    });
  }

  handleLastDayChange(date) {
    if (date) {
      this.setState({
        lastDayWorked: date,
      });
    }
  }

  mailSendOpenModal() {
    this.setState({ mailSendOpen: true });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  openDdformConfirmModal() {
    this.setState({ send_dd_form_confirm: true });
  }

  ddFormConfirmCloseModal() {
    this.setState({
      send_dd_form_confirm: false,
    });
  }

  sendDDForm() {
    if (this.state.hash) {
      this.setState({
        ...this.state,
        sendingDDForm: true,
        send_dd_form_confirm: false,
      });
      let data = new FormData();
      data.append('user_hash', this.state.hash);
      profileService
        .sendDDForm(data)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            handleErrorResponse(res);
          }
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        })
        .catch((error) => {
          toast.error('Failed to send email to user.');
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        });
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  changeTab(tab) {
    this.setState({ tab });
  }

  documentRequest(hash, doc_request) {
    this.setState({ doc_request });
    docsService.requestToFillDocs(hash, doc_request).then(
      (res) => {
        this.setState({
          request_rehire_doc_status: res.success,
          request_rehire_doc: true,
        });
        const hash = '?hash=' + this.state.hash;
        this.props.dispatch(userActions.getProfile(hash));
      },
      (err) => console.log(err),
    );
  }

  docRequestModalClose() {
    this.setState({ request_rehire_doc: false });
  }

  downloadAllDocuments(event, rehire = false, giss = false) {
    let { hash } = this.state.profile;
    let params = {
      uid: this.props.user?.profile?.data?.hash,
      signature: this.props.chat?.settings?.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/${hash}?rehire=true`));
    giss && (url = new URL(`${config.apiUrl}/docs/download/${hash}?giss=true`));
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );
    window.open(url.href);
  }

  downloadAllDocumentsAsPDF(event, rehire = false, giss = false) {
    let { hash } = this.state.profile;
    let params = {
      uid: this.props.user?.profile?.data?.hash,
      signature: this.props.chat?.settings?.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?rehire=true`));
    giss &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?giss=true`));

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );
    window.open(url.href);
  }

  handleChange(event) {
    if (event.target.name === 'notes') {
      if (this.state.permList.includes('Employee Notes')) {
        this.setState({
          [event.target.name]: event.target.value,
          template: 'custommail',
        });
      }
      return;
    }
    this.setState({
      [event.target.name]: event.target.value,
      template: 'custommail',
    });
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  handleCheck(event) {}

  updateNotes(hash) {
    let data = new FormData();
    data.append('hash', hash);
    data.append('note', this.state.notes);
    if (this.state.notes !== null) {
      this.setState({ savingNote: true });
      this.props
        .dispatch(userActions.updateEmployeeNote(data, '?hash=' + hash))
        .then(
          (res) => {
            toast.success('Notes Saved !');
            this.setState({ savingNote: false });
          },
          (err) => {
            toast.error('Notes Cannot be saved');
            this.setState({ savingNote: false });
          },
        );
    }
  }

  componentDidMount() {
    const hash = '?hash=' + this.state.hash;
    this.props.dispatch(userActions.getProfile(hash));
    this.props.dispatch(permissionActions.getPermission());
    let data = new FormData();
    data.append('hash', this.state.hash);
    this.props.dispatch(inventoryActions.getInventoryList(data));
    this.props.dispatch(chatActions.getConversationSettings());
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    
    if (user?.lockProfileSuccess && !prevProps.user?.lockProfileSuccess) {
      this.statusCloseModal();
      toast.success('Profile updated successfully');
      this.setState({
        reloadKey: this.state.reloadKey + 1,
        lastDayReason: '',
        lastDayWorked: moment(),
        loader: false,
      });
    }

    if (user?.lockProfileFailure && !prevProps.user?.lockProfileFailure) {
      this.statusCloseModal();
      toast.error('Failed to update profile');
      this.setState({ loader: false });
    }

    if (user?.changeStatusSuccess && !prevProps.user?.changeStatusSuccess) {
      this.statusCloseModal();
      this.setState({ reloadKey: this.state.reloadKey + 1, loader: false });
    }

    if (user?.changeStatusFailure && !prevProps.user?.changeStatusFailure) {
      this.statusCloseModal();
      this.setState({ loader: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { user, inventory, permission } = nextProps;
    let permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;

      this.setState({
        permList,
      });
    }
    let generalQualificationList = [],
      inventory_list = [];
    if (inventory.inventory) {
      if (inventory.inventory.data) {
        let total_cost = 0;
        inventory.inventory.data.map((item, index) => {
          total_cost += parseInt(item.cost);
          inventory_list.push(
            <div className='inv_item' key={index}>
              <div className='inv_cell'>
                {index + 1 + '. ' + item.unique_id + ' (' + item.type + ') '}

                <NumberFormat
                  value={item.cost}
                  className='cost'
                  displayType={'text'}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  thousandSeparator={true}
                  prefix={'$'}
                />
              </div>
            </div>,
          );
          return inventory_list;
        });
        this.setState({ inventory_list, total_cost });
      }
    }
    if (user.items) {
      const profile = user.items.data;
      const available = profile.active === 'Available' ? true : false;
      this.setState({
        status: profile.active,
        available: available,
        notes: this?.state?.notes ? this?.state?.notes : profile.notes,
        profile,
        active: user.items.data.active,
        userName: profile.first_name,
        user_type: user.items.data.user_type,
        isGuest: profile.status === 3 ? true : false,
        unavailableReason: profile.unavailable_reason,
        otherReason: profile.other_reason,
        is_locked: profile.is_locked,
      });
      if (profile.qualification) {
        profile.qualification.map((item, index) => {
          generalQualificationList.push(
            <p className='crew-profile-detail' key={index}>
              {item}
            </p>,
          );
          return generalQualificationList;
        });
      }
    }
    this.setState({
      generalQualificationList,
    });
    if (user.removeUser) {
      if (user.removeUser.success) {
        this.setState({
          // alertPop: true,
          alertHead: 'Success',
          alertMsg: user.removeUser.message,
          removeOpen: false,
          archiveStep: '3a',
          alertOpen: true,

          // redirect: "/resources"
        });
      } else {
        const hash = '?hash=' + this.state.hash;
        this.props.dispatch(userActions.getProfile(hash));
        this.setState({
          alertPop: true,
          alertHead: 'Error',
          alertMsg: user.removeUser.message,
          alertFunction: '',
          removeOpen: false,
          archiveStep: '3a',
        });
      }
    }
    if (user.notes) {
      if (user.notes.success) {
      } else {
        this.setState({
          alertPop: true,
          alertHead: 'Success',
          alertMsg: user.notes.message,
          alertFunction: '',
        });
      }
      this.props.dispatch(userActions.getProfile('?hash=' + this.state.hash));
    }
  }

  setStatusReturn(status) {
    let step = '2a';
    if (status) {
      this.setState({
        returnDate: moment().format(dateTimeConstants.DATE_FORMAT),
      });
    } else {
      this.setState({ returnDate: '' });
      step = '2b';
    }

    this.setState(
      {
        statusStep: step,
      },
      function () {
        this.componentWillReceiveProps(this.props);
      },
    );
  }

  setStep(step) {
    this.setState({ statusStep: step }, function () {
      this.componentWillReceiveProps(this.props);
    });
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  changeStatus(status) {
    if (status) {
      let stat =
        this.state.status === 'Available' ? 'Unavailable' : 'Available';

      const hash = '?hash=' + this.state.hash;
      let data = new FormData();
      data.append('end_date', this.state.returnDate);
      data.append('hash', this.state.hash);
      data.append('status', stat);
      this.props.dispatch(userActions.changeStatus(data, hash));
      this.setState({ status: stat, loader: true });
    }
  }

  lockProfile() {
    if (!this.state || !this.state.lastDayReason || !this.state.lastDayReason.trim()) {
      this.setState({
        lastDayReasonErr: 'error',
      });
      return;
    }
    var stat = 'Locked';
    var hash = '?hash=' + this.state.hash;
    let data = new FormData();

    data.append('hash', this.state.hash);
    data.append('status', stat);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(
        dateTimeConstants.ISO_DATE_FORMAT,
      ),
    );
    data.append('modify_active_status', true);
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  unlockProfile() {
    if (!this.state) {
      console.error('Component state is not initialized');
      return;
    }
    var stat = 'Unlocked';
    var hash = '?hash=' + this.state.hash;
    let data = new FormData();
    data.append('hash', this.state.hash);
    data.append('status', stat);
    data.append('document', this.state.requireDocs);
    data.append('modify_active_status', true);
    this.props.dispatch(userActions.lockUserToggle(data, hash));
    this.props.dispatch(notificationActions.getCount());
    this.setState({ status: stat, loader: true });
  }

  requireDocs(e) {
    this.setState({ requireDocs: e.target.checked });
  }

  remove() {
    if (!this.state || !this.state.lastDayReason || !this.state.lastDayReason.trim()) {
      this.setState({
        lastDayReasonErr: 'error',
      });
      return;
    }
    let data = new FormData();
    this.statusCloseModal();
    data.append('hash', this.state.hash);
    data.append(
      'last_day_worked',
      moment(this.state.lastDayWorked).format(
        dateTimeConstants.ISO_DATE_FORMAT,
      ),
    );
    data.append('last_day_reason', this.state.lastDayReason);
    this.props.dispatch(userActions.removeEmployee(data));
  }

  goBack() {
    this.props.goBack(this.props.resourceDetails);
  }

  editProfile(hash) {
    this.props.editProfile(hash);
  }

  print() {
    window.print();
  }

  sendMail(hash) {
    let data = new FormData();
    this.mailSendCloseModal();
    data.append('type', 'mail');
    data.append('message', this.state.message);
    data.append('user_hash', hash);

    const self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  onImageError(e) {
    e.target.setAttribute('src', config.apiUrl + '/' + config.altImg);
  }

  render() {
    const { permission } = this.props;

    let permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }

    if (this.state.redirect === '/resources') {
      return <Redirect to={'/dashboard'} />;
    }

    const userData = this.state.profile || {};
    const authUser = this.props.user?.profile?.data || {};

    return (
      <div
        className='resource_container profile_container'
        style={{ marginTop: '60px' }}
      >
        <ProfileHeader
          profile={this.state.profile}
          resourceId={this.state.hash}
          activeTab={this.state.tab}
          hash={this.state.hash}
          permList={permList}
          authUser={authUser}
          userData={userData}
          sendingDDForm={this.state.sendingDDForm}
          requestRehireDoc={this.state.request_rehire_doc}
          docRequest={this.state.doc_request}
          requestRehireDocStatus={this.state.request_rehire_doc_status}
          onToResourceList={this.goBack}
          onPrint={this.print.bind(this)}
          onMailSendOpen={this.mailSendOpenModal.bind(this)}
          onStatusOpen={this.statusOpenModal.bind(this)}
          onRemoveEmployee={this.removeOpenModal.bind(this)}
          onDdFormConfirmOpen={this.openDdformConfirmModal.bind(this)}
          onDocumentRequest={this.documentRequest.bind(this)}
          onDownloadAllDocuments={this.downloadAllDocuments.bind(this)}
          onDownloadAllDocumentsAsPDF={this.downloadAllDocumentsAsPDF.bind(this)}
          onDocRequestModalClose={this.docRequestModalClose.bind(this)}
          breadcrumbType="resources"
          isArchivedEmployees={this.props.isArchivedEmployees}
        />
        
        <TabNavigation
          activeTab={this.state.tab}
          permList={permList}
          hasApplicantHash={!!this.state.profile?.applicant_hash}
          onChangeTab={this.changeTab.bind(this)}
        />
        
        <TabContent
          activeTab={this.state.tab}
          hash={this.state.hash}
          permList={permList}
          reloadKey={this.state.reloadKey}
          authUser={this.props?.user?.profile?.data || {}}
          userData={this.state.profile}
          onSendMail={this.sendMail}
          onViewHistory={() => {}}
          onViewDetails={() => {}}
          onGoBack={this.goBack}
        />

        <Modal
          id='status_popup'
          className='status_popup'
          open={this.state.statusOpen}
          onClose={this.statusCloseModal.bind(this)}
          little
        >
          <div id='statusPopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Current Status</h4>
            </div>
            {this.state.statusStep === '1' && (
              <div className='modal-body'>
                <div className='status_step step1'>
                  <label>
                    {this.state.userName + ' is: '}
                    <span className='green'>{this.state.status}</span>
                  </label>
                  <br />
                  <div className='user-status-edit-wrapper'>
                    <div>
                      {this.state.is_locked === 0 && (
                        <button
                          className='button'
                          onClick={this.handleLockProfile.bind(this)}
                        >
                          Lock Profile
                        </button>
                      )}
                      {this.state.is_locked === 1 && (
                        <button
                          className='button'
                          onClick={this.setStep.bind(this, '1a')}
                        >
                          Unlock Profile
                        </button>
                      )}
                    </div>
                    <div>
                      <button
                        className={`button outlined ${
                          this.state.is_locked === 1 ? 'disabled' : ''
                        }`}
                        onClick={this.setStep.bind(this, '2')}
                        disabled={this.state.is_locked === 1}
                      >
                        {this.state.status === 'Available'
                          ? 'Make Unavailable'
                          : 'Make Available'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.statusStep === '1a' && (
              <div className='modal-body'>
                <div className='status_step step1'>
                  <section className='d-flex flex-column checkb'>
                    <h6 className='text-bold'>
                      Are you sure you want to Unlock the selected employee
                    </h6>

                    {(this.state.profile?.docs_status === -1 ||
                      this.state.profile?.rehire_docs_status === -1) && (
                      <label>
                        <input
                          type='checkbox'
                          onChange={this.requireDocs}
                          defaultChecked={this.state.requireDocs}
                        />
                        <span>Ask to fill Documents</span>
                      </label>
                    )}
                  </section>
                  <div className='user-status-edit-wrapper'>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button disabled'
                        onClick={this.setStep.bind(this, '2')}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button'
                        onClick={this.unlockProfile}
                      >
                        Unlock
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.statusStep === '1b' && (
              <div className='modal-body'>
                <div className='status_step step1'>
                  <section className='d-flex flex-column checkb'>
                    <p>
                      Are you sure you want to Lock the selected employee ?
                    </p>
                  </section>
                  <div className='user-status-edit-wrapper'>
                    <div>
                      <button
                        className='button grey'
                        onClick={this.setStep.bind(this, '2')}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        className='button'
                        onClick={this.setStep.bind(this, '1c')}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.statusStep === '1c' && (
              <div className='modal-body'>
                <div className='status_step step1'>
                  <section className='d-flex flex-column checkb'>
                    <div classNames='full-width'>
                      <p>Last Day Worked</p>
                      <DatePicker
                        className='lastDayWorked'
                        name='lastDayWorked'
                        selected={this.state.lastDayWorked}
                        onChange={this.handleLastDayChange.bind(this)}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode='select'
                      />
                      <textarea
                        rows='3'
                        maxLength={1200}
                        className='lastDayReason'
                        value={this.state.lastDayReason}
                        name='lastDayReason'
                        onChange={this.changeLastDayReason}
                        errors={this.state.lastDayReasonErr}
                      />
                    </div>
                  </section>
                  <div className='user-status-edit-wrapper'>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button grey'
                        onClick={this.setStep.bind(this, '2')}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button'
                        onClick={this.lockProfile}
                      >
                        Lock
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.statusStep === '2' && this.state.available && (
              <div className='modal-body'>
                <div className='status_step step2'>
                  <label>
                    Do you know when {this.state.userName} will return?
                  </label>
                  <button
                    className='button'
                    onClick={this.setStatusReturn.bind(this, true)}
                  >
                    Yes
                  </button>
                  <button
                    className='button grey'
                    onClick={this.setStatusReturn.bind(this, false)}
                  >
                    No
                  </button>
                  <p className='step_no'>2/3</p>
                </div>
              </div>
            )}
            {this.state.statusStep === '2' && !this.state.available && (
              <div className='modal-body'>
                <div className='status_step step2'>
                  <label>Make Available?</label>
                  <button
                    className='button'
                    onClick={this.changeStatus.bind(this, true)}
                    disabled={this.state.loader}
                  >
                    Yes
                  </button>
                  <button
                    className='button grey'
                    onClick={this.statusCloseModal.bind(this)}
                    disabled={this.state.loader}
                  >
                    No
                  </button>
                  <p className='step_no'>2/3</p>
                </div>
              </div>
            )}
            {this.state.statusStep === '2a' && (
              <div className='modal-body'>
                <div className='status_step step4'>
                  <label>Choose date of return:</label>
                  <DatePicker
                    className='returnDateField'
                    name='returnDateField'
                    selected={this.state.returnDateField}
                    onChange={this.handleDateChange.bind(this)}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                    minDate={moment()}
                  />
                  <button
                    className='button'
                    onClick={this.setStep.bind(this, '3')}
                  >
                    Next
                  </button>
                  <p className='step_no'>2/3</p>
                </div>
              </div>
            )}
            {this.state.statusStep === '2b' && (
              <div className='modal-body'>
                <div className='status_step step2'>
                  <label>Make Unavailable?</label>
                  <button
                    className='button'
                    onClick={this.changeStatus.bind(this, true)}
                    disabled={this.state.loader}
                  >
                    Yes
                  </button>
                  <button
                    className='button grey'
                    onClick={this.statusCloseModal.bind(this)}
                    disabled={this.state.loader}
                  >
                    No
                  </button>
                  <p className='step_no'>2/3</p>
                </div>
              </div>
            )}
            {this.state.statusStep === '3' && (
              <div className='modal-body'>
                <div className='status_step step5'>
                  <label>
                    Are you sure you want to switch {this.state.userName} to
                    Unavailable?
                  </label>
                  <p>
                    (returning{' '}
                    {this.state.returnDate === ''
                      ? moment().format('MM/DD/YYYY')
                      : formatDate(this.state.returnDate)}
                    )
                  </p>
                  <button
                    className='button'
                    onClick={this.changeStatus.bind(this, true)}
                    disabled={this.state.loader}
                  >
                    Yes
                  </button>
                  <button
                    className='button grey'
                    onClick={this.statusCloseModal.bind(this)}
                    disabled={this.state.loader}
                  >
                    No
                  </button>
                  <p>Time off must be approved by your supervisor.</p>
                  <p className='step_no'>3/3</p>
                </div>
              </div>
            )}
          </div>
        </Modal>
        <NewModal
          id='remove_popup'
          className='status_popup'
          open={this.state.removeOpen}
          onClose={this.removeCloseModal.bind(this)}
          little
        >
          <div id='removePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>
                Remove Employee:{' '}
                {this.state.profile
                  ? this.state.profile.first_name +
                    ' ' +
                    this.state.profile.last_name
                  : ''}
              </h4>
            </div>
            <div className='modal-body'>
              {this.state.archiveStep == '3a' && (
                <div>
                  <label>Are you sure you want to archive this employee?</label>
                  <br />
                  <button
                    className='button grey'
                    onClick={this.removeCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.collectLastDayWorked.bind(this)}
                  >
                    Archive
                  </button>
                </div>
              )}
              {this.state.archiveStep == '3b' && (
                <div className='status_step step1'>
                  <section
                    className='d-flex flex-column checkb'
                    style={{ padding: '10px' }}
                  >
                    <div classNames='full-width'>
                      <p>Last Day Worked</p>
                      <DatePicker
                        className='lastDayWorked'
                        name='lastDayWorked'
                        selected={this.state.lastDayWorked}
                        onChange={this.handleLastDayChange.bind(this)}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode='select'
                      />
                      <textarea
                        rows='3'
                        maxLength={1200}
                        className='lastDayReason'
                        value={this.state.lastDayReason}
                        name='lastDayReason'
                        onChange={this.changeLastDayReason}
                        errors={this.state.lastDayReasonErr}
                      />
                    </div>
                  </section>
                  <div className='user-status-edit-wrapper'>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button grey'
                        onClick={this.removeCloseModal.bind(this)}
                      >
                        Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        disabled={this.state.loader}
                        className='button'
                        onClick={this.remove}
                      >
                        Archive
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </NewModal>

        <InventoryAlertModal
          isOpen={this.state.inventoryUserAlert}
          onClose={() => this.setState({ inventoryUserAlert: false })}
          action={this.state.inventoryAlertAction || 'remove'}
          userHash={this.state.hash}
        />

        <Modal
          id='email_popup'
          className='status_popup'
          open={this.state.mailSendOpen}
          onClose={this.mailSendCloseModal.bind(this)}
          little
        >
          <div id='emailPopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Custom Message</h4>
            </div>
            <div className='modal-body'>
              <textarea
                name='message'
                cols='80'
                rows='10'
                value={this.state.message ?? ''}
                onChange={this.handleChange.bind(this)}
              />

              <p className='step_no'>
                Signature will automatically be included.
              </p>

              <button
                className='button grey'
                onClick={this.mailSendCloseModal.bind(this)}
              >
                Cancel
              </button>
              <button
                className='button'
                onClick={this.sendMail.bind(this, this.state.hash)}
              >
                Send
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          id='remove_popup'
          className='status_popup'
          open={this.state.send_dd_form_confirm}
          onClose={this.ddFormConfirmCloseModal.bind(this)}
          little
        >
          <div id='removePopup'>
            <div className='modal-head'>
              <h4 className='modal-title'>Direct Deposit Form</h4>
            </div>
            <div className='modal-body'>
              <label>
                This will send an email to{' '}
                {this.state.profile
                  ? this.state.profile.first_name + ' ' + this.state.profile.last_name
                  : 'this employee'}
                , with Direct Deposit form link.
              </label>
              <br />
              <button
                className='button grey'
                onClick={this.ddFormConfirmCloseModal.bind(this)}
              >
                Cancel
              </button>
              <button
                className='button'
                onClick={this.sendDDForm.bind(this)}
              >
                Send
              </button>
            </div>
          </div>
        </Modal>
        
        <ReactModal
          isOpen={this.state.alertOpen}
          onClose={this.alertCloseModal.bind(this)}
          contentLabel='Minimal Modal Example'
          overlayClassName='alertPopup'
        >
          <div id='statusPopup' className='popupModal'>
            <div className='modal-head'>
              <h4 className='modal-title'>{this.state.head}</h4>
            </div>
            <div className='modal-body'>
              <p>{this.state.alertMsg}</p>
              <div className='btn_list'>
                <button
                  className='button'
                  onClick={this.alertCloseModal.bind(this)}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </ReactModal>

      </div>
    );
  }
}

Profile.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  permission: PropTypes.object.isRequired,
  inventory: PropTypes.object.isRequired,
  chat: PropTypes.object.isRequired,
  hash: PropTypes.string.isRequired,
  goBack: PropTypes.func.isRequired,
  editProfile: PropTypes.func.isRequired,
  resourceDetails: PropTypes.object,
  isArchivedEmployees: PropTypes.bool,
};

function mapStateToProps(state) {
  const { user, permission, inventory, chat } = state;
  return {
    user,
    permission,
    inventory,
    chat,
  };
}

const connectedRegisterPage = connect(mapStateToProps)(Profile);
export { connectedRegisterPage as Profile };
